import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    categories: [],
    loading: false,
    error: null
};

const categoryAdminSlice = createSlice({
    name: "categoryAdmin",
    initialState,
    reducers: {
        fetchCategoriesStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchCategoriesSuccess(state, action) {
            state.loading = false;
            state.categories = action.payload;
        },
        fetchCategoriesFail(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        addFilterToCategory(state, action) {
            const { categoryId, groupId, filter } = action.payload;
            const category = state.categories.find(c => c._id === categoryId);
            if (!category) return;

            const group = category.filterGroups.find(g => g._id === groupId);
            if (!group) return;

            group.filters.push(filter);
        },
        addFilterGroupToCategory(state, action) {
            const { categoryId, filterGroup } = action.payload;
            const category = state.categories.find(c => c._id === categoryId);
            if (!category) return;

            category.filterGroups.push({ ...filterGroup, filters: [] });
        },
        toggleEasyAccess(state, action) {
            const { categoryId, filterId, filterName } = action.payload;
            const category = state.categories.find(c => c._id === categoryId);
            if (!category) return;

            category.easyAccessFilters = category.easyAccessFilters || [];
            const exists = category.easyAccessFilters.some(f => f._id === filterId);

            if (exists) {
                // Remove if already exists
                category.easyAccessFilters = category.easyAccessFilters.filter(
                    (f) => f._id !== filterId
                );
            } else {
                // Add if not exists
                category.easyAccessFilters.push({ _id: filterId, name: filterName });
            }
        },
        // NEW: Set generic error
        setError(state, action) {
            state.error = action.payload;
        }
    }
});

export const {
    fetchCategoriesStart,
    fetchCategoriesSuccess,
    fetchCategoriesFail,
    addFilterGroupToCategory,
    addFilterToCategory,
    toggleEasyAccess,
    setError  // ✅ add this export
} = categoryAdminSlice.actions;

export const CategoryReducer = categoryAdminSlice.reducer;
